"use client";

import { useEffect } from "react";
import { useAssistantContextStore } from "@/lib/stores/assistantContext";

export function useAssistantContext() {
  const data = useAssistantContextStore((state) => state.data);
  const status = useAssistantContextStore((state) => state.status);
  const error = useAssistantContextStore((state) => state.error);
  const lastLoadedAt = useAssistantContextStore((state) => state.lastLoadedAt);
  const lastInvalidatedAt = useAssistantContextStore((state) => state.lastInvalidatedAt);
  const fetch = useAssistantContextStore((state) => state.fetch);
  const refresh = useAssistantContextStore((state) => state.refresh);

  useEffect(() => {
    if ((status === "idle" || status === "error") && !data) {
      void fetch();
    }
  }, [data, fetch, status]);

  useEffect(() => {
    if (!lastInvalidatedAt || status === "loading") return;
    if (lastLoadedAt && lastInvalidatedAt <= lastLoadedAt) return;
    void refresh();
  }, [lastInvalidatedAt, lastLoadedAt, refresh, status]);

  return {
    context: data,
    status,
    error,
    refresh,
  };
}
